import {
    ADV_PRODUCTS_SUCCESS,
    ADV_PRODUCTS_LOADING

} from '../actions/AdvProductsAction';

const initialState = {
    advProductsData: null,
    isLoading: true,
};

const AdvProductsReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ADV_PRODUCTS_SUCCESS:
            return { ...state, advProductsData: action.data, isLoading: false };

        case ADV_PRODUCTS_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default AdvProductsReducer;
